import { render, staticRenderFns } from "./u-tit-wrap-top-line.vue?vue&type=template&id=fb9838a0&scoped=true&"
import script from "./u-tit-wrap-top-line.vue?vue&type=script&lang=js&"
export * from "./u-tit-wrap-top-line.vue?vue&type=script&lang=js&"
import style0 from "./u-tit-wrap-top-line.vue?vue&type=style&index=0&id=fb9838a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9838a0",
  null
  
)

export default component.exports